import { render, staticRenderFns } from "./AdminArea.vue?vue&type=template&id=79a5e79e&"
import script from "./AdminArea.vue?vue&type=script&lang=js&"
export * from "./AdminArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports